export interface RateLimitRequest {
  time: number;
  endpoint?: string;
}

export interface EndpointBreakdown {
  endpoint: string;
  count: number;
}

export function summarizeEndpointCounts(
  requests: RateLimitRequest[],
  maxEndpoints = 5,
): { counts: Record<string, number>; topEndpoints: EndpointBreakdown[] } {
  const counts = requests.reduce<Record<string, number>>((acc, req) => {
    const key = req.endpoint || "unknown";
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  const topEndpoints = Object.entries(counts)
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .slice(0, maxEndpoints)
    .map(([endpoint, count]) => ({ endpoint, count }));

  return { counts, topEndpoints };
}
